export const ComponentName = Object.freeze({
  article_hero: "article_hero",
  audio: "audio",
  audioplayer: "audioplayer",
  campaign: "campaign",
  description_list: "description_list",
  exhibition_hero: "exhibition_hero",
  featured_items: "featured_items",
  frontpage_hero: "frontpage_hero",
  video_hero: "video_hero",
  gallery: "gallery",
  InfoViewer: "InfoScreenViewer",
  image_module: "image_module",
  list_items: "list_items",
  related_content: "related_content",
  rich_text: "rich_text",
  search_items: "search_items",
  subpages: "subpages",
  video: "video",
  guide_menu: "guide_menu",
});

export const CampaignDisplayType = Object.freeze({
  LEFT: "left",
  RIGHT: "right",
  FULLSCREEN: "fullscreen",
  FULLSCREEN_FRAME: "fullscreen_frame"
});

export let LIB = {};
export const setLIB = i18n => {
  LIB = i18n;
};

export const SubBrand = Object.freeze({
  SMK: "smk.dk",
  SMK2: "Smk.dk",
  Parkmuseerne: "Parkmuseerne",
  CATS: "CATS",
  "SMK Guide": "SMK Guide"
});

export const Color = Object.freeze({
  BLACK: "#333333",
  GREY_DARK: "#666666",
  GREY_LIGHT: "#F5F5F5"
});

export const ListLayoutType = Object.freeze({
  GRID: "grid",
  SLIDER: "slider"
});

export const FrameStates = Object.freeze({
  INIT_FRONT: "initFront",
  FRONT: "front",
  LEAVE_FRONT: "leaveFront",
  INIT_INFO: "initInfo",
  INFO: "info",
  INIT_SECTION: "initSection",
  SECTION: "section",
  LEAVE_SECTION: "leaveSection",
  INIT_EXHIBITION: "initExhibition",
  EXHIBITION: "exhibition",
  LEAVE_EXHIBITION: "leaveExhibition",
  MENU_INIT: "menuInit",
  MENU: "menu",
  MENU_SUB: "menuSub",
  CAMPAIGN: "campaign",
  INIT_FACT: "initFact",
  FACT: "fact"
});

export const FrameAnimation = Object.freeze({
  ENTER_DELAY: 2000
});

export const SortBy = Object.freeze({
  ascending: "ascending",
  descending: "descending",
  ASC: "asc",
  DESC: "desc"
});

export const ListType = Object.freeze({
  CALENDAR: "calendar"
});

export const Icon = Object.freeze({
  ARROW_DOWN: "arrow-down",
  ARROW_LONG_LEFT: "arrow-long-left",
  ARROW_LONG_RIGHT: "arrow-long-right",
  ARROW_LONGER_RIGHT: "arrow-longer-right",
  ARROW_LEFT: "arrow-left",
  ARROW_RIGHT: "arrow-right",
  CLOCK: "clock",
  DOWNLOAD: "download",
  DROPDOWN: "dropdown",
  DROPDOWN_TINY: "dropdown-tiny",
  DROPDOWN_TINY_ARROW: "dropdown-tiny-arrow",
  FULLSCREEN: "fullscreen",
  FULLSCREEN_EXIT: "fullscreen-exit",
  IIIF: "iiif",
  LOGO: "logo",
  LOGO_DETAILED: "logo-detailed",
  LOGO_THY: "logo-thy",
  LOGO_THY_DETAILED: "logo-thy-detailed",
  LOGO_FRAME: "logo-frame",
  LOGO_THY_FRAME: "logo-thy-frame",
  Parkmuseerne: "logo-park",
  CATS: "logo-cats",
  "SMK Guide": "logo-smkguide",
  MENU_TOGGLE_BAR: "menu-toggle-bar",
  PAUSE: "pause",
  PLAY: "play",
  PLAY2: "play2",
  CLOSE: "close",
  PLUS: "plus",
  SEARCH: "search",
  LOGO_GUIDE: "logo-guide",
  GUIDE_HEADSET: "guide-icon-headset",
});




// WEBPACK FOOTER //
// ./src/constants/consts-types.js